import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { paths } from 'utilities/routes';
import { generateSlug } from 'utilities/helpers/generateSlug';
import { ArticlesSearch } from '../articles-search/index';
import { locationShape } from 'utilities/data/proptypesShapes';
import './view.scss';

export const TypesView = ({ types, currentType, location }) => {
    const generateHref = (type) => {
        if (type === 'wszystkie') {
            if (location.search === '?search=' || !location.search) {
                return `${paths.wszystkoODrzwiach}`;
            }
            return `${paths.wszystkoODrzwiach}${location.search}`;
        }

        if (location.search === '?search=' || !location.search) {
            return `${paths.artykuly}/${generateSlug(type)}`;
        }
        return `${paths.artykuly}/${generateSlug(type)}${location.search}`;
    };

    return (
        <section className="types">
            <div className="types__categories">
                <Link
                    className={
                        classnames('types__type', {
                            'types__type--active': currentType === 'wszystkie'
                        })
                    }
                    to={ generateHref('wszystkie') }
                >
                    Wszystkie
                </Link>
                {
                    types.sort().map((type) => (
                        <Link
                            className={
                                classnames('types__type', {
                                    'types__type--active': currentType === generateSlug(type)
                                })
                            }
                            to={ generateHref(type) }
                        >
                            {type}
                        </Link>
                    ))
                }
            </div>
            <ArticlesSearch currentType={ currentType } />
        </section>
    );
};

TypesView.propTypes = {
    types: PropTypes.instanceOf(Array).isRequired,
    currentType: PropTypes.string.isRequired,
    location: PropTypes.shape(locationShape).isRequired
};